import { COLORS } from '@btime/constants'
import { useLoggedUser, useLogout } from '@btime/react-session'
import React from 'react'

import { SmallText } from '../presentation/Text'
import FullPageTemplate from './FullPageTemplate'
import Icon from '../shapes/Icon'
import Link from '../actions/Link'
import Logo from '../shapes/Logo'
import MPageHeader from '../presentation/M.PageHeader'
import Separator from '../helpers/Separator'

const SimpleAuthPageTemplate = ({ returnTo, onReturn, children, noHeadMargin, title }) => {
  const user = useLoggedUser()
  const logout = useLogout()

  return (
    <FullPageTemplate>
      <MPageHeader
        title={title}
        leftContent={
          !!onReturn || !!returnTo ? (
            <Link block onClick={onReturn} to={returnTo}>
              <Icon name="BsArrowLeftShort" size="1.4rem" color={COLORS.dark3} />
            </Link>
          ) : (
            <Logo width="3.5rem" />
          )
        }
        rightContent={
          !!user &&
          !!user.id && (
            <Link onClick={logout} bold>
              <SmallText align="right">Sair</SmallText>
            </Link>
          )
        }
      />
      {!noHeadMargin && <Separator weight={4} />}
      {children}
    </FullPageTemplate>
  )
}

export default SimpleAuthPageTemplate
